exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".deployment-tbl-heading-labels {\n  padding-left: 8px; }\n", ""]);

// exports
